module.exports = __webpack_public_path__ + "static/img/14000040.c1f39dd3.png";